import { render, staticRenderFns } from "./IndemnityModalStep4.vue?vue&type=template&id=45adb235&scoped=true"
import script from "./IndemnityModalStep4.vue?vue&type=script&lang=js"
export * from "./IndemnityModalStep4.vue?vue&type=script&lang=js"
import style0 from "./IndemnityModalStep4.vue?vue&type=style&index=0&id=45adb235&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45adb235",
  null
  
)

export default component.exports